import React from "react";
import css from "./section.module.css";
import resources from "../../../../resources/index";
import { BsShieldCheck } from "react-icons/bs";
import { FaArrowRight, FaCheckCircle, FaFingerprint } from "react-icons/fa";
import { Link } from "react-router-dom";
const Section3 = () => {

  const listPoints = [
    { title: "Thought leadership" },
    { title: "Personal branding" },
    { title: "Modernized prospecting" },
    { title: "Better win rates" },
    { title: "Showcasing success" },
    { title: "Sales compliance" },
  ];

  return (
    <div className={css.section3_wrapper}>

      <div className={css.section3}>

        <div className={css.text_div}>
          <div className={css.text}>
            <div className={css.icon_div}>
              <BsShieldCheck className={css.icon} />
            </div>
            <h2>Advanced Analytics, Understand Business</h2>
            <p>
              Distinctively promote parallel vortals with ubiquitous e-markets.
              Proactively benchmark turnkey optimize next-generation strategic
              leadership without resource sucking ideas.
            </p>
            <ul className={css.list_wrapper}>
              {listPoints.map((point, index) => {
                return (
                  <li key={index} className={css.list_point}>
                    <FaCheckCircle className={css.list_tick} />{" "}
                    <p>{point.title}</p>
                  </li>
                );
              })}
            </ul>
            <Link to="/about-us" className={css.know_more}>
              <p>Know More About Us</p> <FaArrowRight className={css.arrow} />
            </Link>
          </div>
        </div>

        <div className={css.img_div}>
          <img src={resources.images.home_sec4} alt="home section 3" />
        </div>

      </div>

      {/* section 4 part 2 */}
      <div className={`${css.section3} ${css.section3_small_screen}`}>

        <div className={css.img_div}>
          <img src={resources.images.home_sec4_2} alt="home section 3" />
        </div>

        <div className={css.text_div}>
          <div className={css.text}>
            <div
              style={{ backgroundColor: "#0b163f" }}
              className={css.icon_div}
            >
              <FaFingerprint className={css.icon} />
            </div>
            <h2>Match Everything to Brand and Style</h2>
            <p>
              Intrinsicly pontificate reliable metrics with enabled. Holisticly
              maintain clicks-and-mortar manufactured products empower viral
              customer service through resource deliverables.
            </p>
            <br />
            <p>
              Customer service through resource pontificate reliable metrics
              with enabled expedite resource maximizing information maintain
              manufactured products.
            </p>

            <Link to="/about-us" className={css.know_more}>
              <p>Know More About Us</p> <FaArrowRight className={css.arrow} />
            </Link>
          </div>
        </div>
        
      </div>

    </div>
  );
};

export default Section3;
